import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import getBaseUrl from "../utils/apiUrl";
import token from "../utils/tokenAuthorization";
import formatDate from "../utils/formatDate";

const initialState = {
    list: [],
    izinList: [],
    headers: {
        total_siswa: 0,
        siswa_telat_masuk: 0,
        siswa_datang_tepat_waktu: 0,
        alpha: 0,
    },
    listKelas: [],
    currentPage: 1,
    search: '',
    kelas: '',
    startText: 'Tanggal mulai',
    endText: 'Tanggal berakhir',
    startTime: formatDate(new Date()),
    endTime: null,
    isLoading: true,
    isLoadingList: true,
    statusResApi: '',
    messageResApi: '',
    isDisplayMessage: false,
};

// TODO: update endpoint URL to match your actual API
export const getSiswaAttendanceHistory = createAsyncThunk(
    "siswaAttendanceHistory/get",
    async ({ search, start_time, end_time } = {}, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                getBaseUrl + '/api/student-kelas',
                {
                    headers: { Authorization: `Bearer ${token()}` },
                    params: { search, start_time, end_time },
                    timeout: 20000
                }
            );
            return response.data;
        } catch (error) {
            if (error.code === 'ECONNABORTED') return rejectWithValue('Request timeout');
            if (error.response?.data?.admin === false) return rejectWithValue('Permission denied');
            return rejectWithValue(error.message);
        }
    }
);

const siswaAttendanceHistorySlice = createSlice({
    name: 'siswaAttendanceHistory',
    initialState,
    reducers: {
        updateStateSiswaAttendance: (state, action) => {
            const { name, value } = action.payload;
            state[name] = value;
        },
        resetTableAttendance: (state) => {
            state.list = [];
            state.izinList = [];
            state.isLoading = true;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSiswaAttendanceHistory.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getSiswaAttendanceHistory.fulfilled, (state, action) => {
                state.isLoading = false;
                state.list = action.payload.data.absensi;
                state.izinList = action.payload.data.izin || [];
                state.headers = action.payload.data.headers;
                state.kelas = action.payload.data.kelas;
            })
            .addCase(getSiswaAttendanceHistory.rejected, (state, action) => {
                state.isLoading = false;
                state.statusResApi = action.error.message;
                state.messageResApi = action.payload;
                state.isDisplayMessage = true;
            })

    }
});

export const { updateStateSiswaAttendance, resetTableAttendance } = siswaAttendanceHistorySlice.actions;
export default siswaAttendanceHistorySlice.reducer;
